export default __webpack_public_path__ + "static/media/R7SR10.730666ce.png";